import { defineComponent as _defineComponent } from 'vue'
import { onUpdated, reactive } from "vue";
import Multiselect from "@vueform/multiselect";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputSelectSearch',
  props: {
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  fetchOptions: {
    type: Function,
    required: true,
  },
  valorInicial: {
    type: Object,
  },
  label: String,
  required: Boolean,
  disabled: Boolean,
  placeholder: String,
},
  emits: ["changeNome", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;
const onInput = (event: { value: number; label: string }) => {
  emit("update:modelValue", event?.value || undefined);
  emit("changeNome", event?.label || undefined);
};

onUpdated(async () => {
  if (props?.valorInicial?.value) {
    data.valorInicial.value = props?.valorInicial?.value;
    data.valorInicial.label = props?.valorInicial?.label;
  }
});

const data = reactive({
  valorInicial: { value: undefined, label: undefined },
});

const __returned__ = { props, emit, onInput, data, get Multiselect() { return Multiselect } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})